import { createAppResourceService } from "@/global";
import { WORK_OFFLINE } from "@/resources/constants";
import { LocationOccupancyState } from "@/resources/locationOccupancy";

const metaService = createAppResourceService("meta");

export const useLocationOccupancyState = () =>
  metaService.useGetCustom<LocationOccupancyState>("location-occupancy", {
    enabled: !WORK_OFFLINE,
    refetchOnWindowFocus: true,
  });
